// redux/reducers/mesAvantagesReducer.js

import {
    SET_MES_AVANTAGES_LOADING,
    FETCH_MES_AVANTAGES_REQUEST,
    FETCH_MES_AVANTAGES_SUCCESS,
    FETCH_MES_AVANTAGES_FAILURE,
} from "../actions/mesAvantagesActions";

const initialState = {
    loading: false,
    error: null,
    avantages: [],
    categories: [], // ✅ AJOUTÉ
    avantagesDisponibles: [],
    avantagesAttribues: [],
};

const mesAvantagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MES_AVANTAGES_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case FETCH_MES_AVANTAGES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_MES_AVANTAGES_SUCCESS:
            // ✅ La réponse contient { avantages: [...], categories: [...] }
            return {
                ...state,
                loading: false,
                avantages: action.payload.avantages || [],
                categories: action.payload.categories || [], // ✅ AJOUTÉ
                avantagesDisponibles: action.payload.avantagesDisponibles || action.payload.avantages || [],
                avantagesAttribues: action.payload.avantagesAttribues || [],
                error: null,
            };

        case FETCH_MES_AVANTAGES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default mesAvantagesReducer;
